import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Header from 'components/ui/Header';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import DotMenu from 'components/ui/DotMenu';
import DotMenuItem from 'components/ui/DotMenuItem';
import AlertHelper from 'helpers/AlertHelper';
import BotReportApi from 'api/bot-report';

const BotReportEditHeader = ({ report, saving, onClickSave }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const backLinkPath = `/botreports/${report.id}`;

  const handleRemove = async () => {
    const result = await AlertHelper.confirmDanger();

    if (result.value) {
      await BotReportApi.delete(report.id);
      history.push(`/bots/${report.bot_id}?tab=reports`);
    }
  };

  return (
    <Header>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div className="me-3">
            <Link to={backLinkPath}>
              <FiArrowLeft size={24} />
            </Link>
          </div>

          <div>
            <h2 className="m-0 p-0 fw-lighter">{report.name}</h2>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <SubmitButton type="button" className="me-3 btn btn-outline-light" loading={saving} onClick={onClickSave} />

          <DotMenu vertical={true} color="#fff">
            <DotMenuItem onClick={handleRemove} type="button">
              <div className="text-danger">{t('actions.remove')}</div>
            </DotMenuItem>
          </DotMenu>
        </div>
      </div>
    </Header>
  );
};

export default BotReportEditHeader;
